<template>
    <nav @click.self="is_show = false" v-if="is_show" class="w-full h-full left-0 top-0 bg-black/50 backdrop-blur-sm fixed z-50 p-2 flex justify-end">
        <div class="w-auto h-1/2 bg-white rounded p-3">
            <button @click="" class="w-full py-0.5 px-2 text-start">Create Dir</button>
            <button class="w-full py-0.5 px-2 text-start">Create File</button>
        </div>
    </nav>
</template>

<script>
export default {
    data() {
        return {
            is_show: false
        }
    }
}
</script>